import React, { Fragment } from 'react';

import { ExperienceSuccessTracker } from '@atlassian/jira-common-experience-tracking-viewing/src/view/experience-tracker-consumer/result-declared/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { useIsCurrentRouteRedirect } from './utils.tsx';

/**
 * PageContainerSuccessTracker is a copy of the old NavigationSuccessTracker component from this path:
 * jira/src/packages/navigation-apps/atlassian-navigation/src/controllers/navigation-success-tracker/main.tsx
 * Which used to mount on every page. But now it doesn't we aren't getting page container success events.
 *
 * So we are mounting ExperienceSuccessTracker here just so the parent event fires and our SLO works again.
 * See this thread for more info: https://atlassian.slack.com/archives/C075QTJBJ6S/p1752445800976529
 *
 * Not sure if ExperienceSuccess is explicitly required here, but it was in the old component, so we are keeping it for now.
 */
const PageContainerSuccessTrackerInner = ({ children }: React.PropsWithChildren<{}>) => {
	const isRedirect = useIsCurrentRouteRedirect();
	if (isRedirect) {
		return (
			<>
				{children}
				<ExperienceSuccess experience="pageContainer" />
			</>
		);
	}
	return (
		<ExperienceSuccessTracker
			location="pageContainer"
			parentProviders={null}
			failureEventAttributes={null}
		>
			{children}
			<ExperienceSuccess experience="pageContainer" />
		</ExperienceSuccessTracker>
	);
};

export const PageContainerSuccessTracker = componentWithCondition(
	() => fg('jfp-magma-nav4-page-container-success-fix'),
	PageContainerSuccessTrackerInner,
	Fragment,
);
